export default {
  'primary': '#18572A',
  'secondary': '#ECB030',
  'accent': '#0d802e'
}
